import { IChannel } from 'src/app/models/channels.interface';

export interface IChannelState {
  channels: IChannel[];
  changeChannel: boolean;
}

export const initialChannelState: IChannelState = {
  channels: [],
  changeChannel: true
};

